import { forwardRef, useCallback } from 'react'

import { type Except } from 'type-fest'

import { type ZodFormProviderProps, ZodFormSubmitProvider } from '@/components/atoms/Form/ZodFormSubmitProvider'

import { type JudicialVolunteerSearchFormData, JudicialVolunteerSearchFormZod } from './JudicialVolunteerSearchFormZod'

export interface JudicialVolunteerSearchFormProviderProps extends Except<
  ZodFormProviderProps<typeof JudicialVolunteerSearchFormZod>,
  'schema' | 'onFormSubmit' | 'values' | 'defaultValues' | 'resetOnSubmit'
> {
  onFormSubmit: (volunteerCodes: string) => Promise<void> | void
}

export const JudicialVolunteerSearchFormProvider = forwardRef<
  HTMLFormElement,
  JudicialVolunteerSearchFormProviderProps
>(({ onFormSubmit, children, ...props }, ref) => {
  const submit = useCallback(
    (data: JudicialVolunteerSearchFormData) => onFormSubmit(data.volunteerCode),
    [onFormSubmit]
  )
  return (
    <ZodFormSubmitProvider
      schema={JudicialVolunteerSearchFormZod}
      defaultValues={{ volunteerCode: '' }}
      ref={ref}
      {...props}
      resetOnSubmit
      onFormSubmit={submit}>
      {children}
    </ZodFormSubmitProvider>
  )
})
